<template>
    <div>
    <!-- add after this -->

    <!-- start breadbrumbs -->
		<div class="mt-4 mb-4 d-print-none">
			<nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/interhom/">Home</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/default.stm">Sustainability</a></li>
                    <li class="breadcrumb-item"><a href="/sustainability/building-energy-disclosure.stm">Building Energy Disclosure Project</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Registration</li>                   
                </ol>
			</nav>
		</div>
		<!-- end breadbrumbs -->
		<div class="row">
			<main class="col-12 col-lg-9">
                <div class="cw-content-nosidenav">
                    <!-- ***** start custom content ***** -->
                    <h1>Registration</h1>
                    <h2 class="d-print-none">Summary</h2>
                    <!--<h3>Participant Agreement Information</h3>

    <div v-for="(p,i) in participantList" :key="i">
        <div class="row no-gutters mb-1">
            <div class="col-12 col-md-auto mr-2">Organization's/participant's name:</div>
            <div class="col-12 col-md-auto font-weight-bold">{{p.participantName}}</div>
        </div>

        <div class="row no-gutters mb-1">
            <div class="col-12 col-md-auto mr-2">Full name:</div>
            <div class="col-12 col-md-auto font-weight-bold">{{p.fullName}}</div>
        </div>
        <div class="row no-gutters mb-1">
            <div class="col-12 col-md-auto mr-2">Job title:</div>
            <div class="col-12 col-md-auto font-weight-bold">{{p.jobTitle}}</div>
        </div>
        <div class="row no-gutters mb-1">
            <div class="col-12 col-md-auto mr-2">Address:</div>
            <div class="col-12 col-md-auto font-weight-bold">{{p.address}}</div>
        </div>
        <div class="row no-gutters mb-1">
            <div class="col-12 col-md-auto mr-2">Phone:</div>
            <div class="col-12 col-md-auto font-weight-bold">{{p.phone}}</div>
        </div>
        <div class="row no-gutters mb-1">
            <div class="col-12 col-md-auto mr-2">Email:</div>
            <div class="col-12 col-md-auto font-weight-bold">{{p.email}}</div>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col">
            <button type="button" class="btn btn-outline-secondary" @click="editParticipant">Edit</button>
        </div>
    </div>-->
                    <!-- participation agreement -->

                    <ParticipationAgreementWord />

                    <!--<div v-for="(item, index) in participationList" :key="10+index">
        <div class="row no-gutters mb-1">
            <div class="col-12 col-md-auto mr-2">Full name:</div>
            <div class="col-12 col-md-auto font-weight-bold">{{item.fullName}}</div>
        </div>
        <div class="row no-gutters mb-1">
            <div class="col-12 col-md-auto mr-2">Job title:</div>
            <div class="col-12 col-md-auto font-weight-bold">{{item.jobTitle}}</div>
        </div>
        <div class="row no-gutters mb-1">
            <div class="col-12 col-md-auto mr-2">Date:</div>
            <div class="col-12 col-md-auto font-weight-bold">{{item.signedDate}}</div>
        </div>
    </div>-->
                    <p style="page-break-before: always" />
                    <div class="row mt-3 d-print-none">
                        <div class="col">
                            <button type="button" class="btn btn-outline-secondary" @click="editParticipation">Edit</button>
                        </div>
                    </div>


                    <!-- Organization-->

                    <div v-for="(item,index) in contactList" :key="index">
                        <h3 v-if="index ===0 || index === 2" class="mt-4">{{item.question}}</h3>

                        <div v-else class="row no-gutters mb-1">
                            <div class="col-12 col-md-auto mr-2">{{item.question}}:</div>
                            <div class="col-12 col-md-auto font-weight-bold">{{item.answer}}</div>
                        </div>

                    </div>
                    <div class="row mt-3 d-print-none">
                        <div class="col">
                            <button type="button" class="btn btn-outline-secondary" @click="editContact">Edit</button>
                        </div>
                    </div>

                    <!-- building information -->
                    <div class="mt-5">
                        <h3 class="mb-4">Building information</h3>

                        <div v-if="propertyList.length >= 1">
                            <div v-for="(item, index) in propertyList" :key="index">
                                <h4>{{item.propertytype}}</h4>
                                <p class="small">{{item.propertydesc}}</p>
                                <div v-if="!hasAccount || hasAccount === 'false'">
                                    <div class="row no-gutters mb-1" v-for="(p, i) in item.slice(2)" :key="i">
                                        <div class="col-12 col-md-auto mr-2" v-if="i < (item.length - 3)">{{p.question}}:</div>
                                        <div class="col-12 col-md-auto font-weight-bold">{{p.answer}}</div>
                                    </div>
                                </div>
                                <div v-if="hasAccount || hasAccount === 'true'">
                                    <div class="row no-gutters mb-1">
                                        <div class="col-12 col-md-auto mr-2">Business address:</div>
                                        <div class="col-12 col-md-auto font-weight-bold">{{item[item.length-1].address}}</div>
                                    </div>
                                    <div class="row no-gutters mb-1">
                                        <div class="col-12 col-md-auto mr-2">Postal code:</div>
                                        <div class="col-12 col-md-auto font-weight-bold">{{item[item.length-1].postalCode}}</div>
                                    </div>
                                    <h3 class="mt-4">Portfolio Manager information:</h3>
                                    <div class="row no-gutters mb-1">
                                        <div class="col-12 col-md-auto mr-2">Portfolio Manager Username:</div>
                                        <div class="col-12 col-md-auto font-weight-bold">{{item[item.length-1].pmUsername}}</div>
                                    </div>
                                </div>
                                <div v-else>
                                    <h4 class="mt-4">Portfolio Manager information</h4>
                                    <div class="row no-gutters mb-1">
                                        <div class="col-12 col-md-auto mr-2">How many physical buildings do you consider part of your property?:</div>
                                        <div class="col-12 col-md-auto font-weight-bold">
                                            {{item[item.length-1].physicalBuilding}}
                                        </div>
                                    </div>
                                    <div class="row no-gutters mb-1">
                                        <div class="col-12 col-md-auto mr-2">Approximate Building Occupancy:</div>
                                        <div class="col-12 col-md-auto font-weight-bold">{{item[item.length-1].buildingOccupancy}}</div>
                                    </div>
                                    <div class="row no-gutters mb-1">
                                        <div class="col-12 col-md-auto mr-2">My property energy consumption includes <a href="https://portfoliomanager.energystar.gov/pm/glossary#Parking" target="_blank">parking</a> area:</div>
                                        <div class="col-12 col-md-auto font-weight-bold">{{item[item.length-1].parking}}</div>
                                    </div>
                                    <div class="row no-gutters mb-1">
                                        <div class="col-12 col-md-auto mr-2">Parking GFA (if yes above):</div>
                                        <div class="col-12 col-md-auto font-weight-bold">{{item[item.length-1].parkingGFA}}</div>
                                    </div>
                                </div>
                                <div>
                                    <div class="row no-gutters mb-1">
                                        <div class="col-12 col-md-auto mr-2">Additional building information (recent renovation, retrofit etc.):</div>
                                        <div class="col-12 col-md-auto font-weight-bold">{{item[item.length-1].additionalInfo}}</div>
                                    </div>
                                </div>
                                <div v-if="!hasAccount || hasAccount === 'false'">
                                    <h5 class="mt-4">Manitoba Hydro account information:</h5>
                                    <div v-for="(a, i) in getAccountInfo(index)" :key="i">
                                        <div class="row no-gutters mb-1">
                                            <div class="col-12 col-md-auto mr-2">Electric meter number:</div>
                                            <div class="col-12 col-md-auto"><span class="font-weight-bold">{{a.hydroNumber}}</span></div>
                                        </div>
                                        <div class="row no-gutters mb-1">
                                            <div class="col-12 col-md-auto mr-2">Natural gas meter number:</div>
                                            <div class="col-12 col-md-auto"><span class="font-weight-bold">{{a.gasNumber}}</span></div>
                                        </div>
                                        <div class="row no-gutters mb-1">
                                            <div class="col-12 col-md-auto mr-2">MB Hydro account number <span class="small">(14-digit)</span>:</div>
                                            <div class="col-12 col-md-auto"><span class="font-weight-bold">{{a.accountNumber}}</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3 d-print-none">
                            <div class="col">
                                <button type="button" class="btn btn-outline-secondary" @click="editBuilding">Edit</button>
                            </div>
                        </div>
                    </div>


                    <div v-if="!hasAccount" class="mt-5">
                        <p style="page-break-before: always" />
                        <HydroAgreementWord />

                        <div v-for="(a, i ) in hydroList" :key="i">
                            <div class="row no-gutters mb-1">
                                <div class="col-12 col-md-auto mr-2">First Name:</div>
                                <div class="col-12 col-md-auto"><span class="font-weight-bold">{{a.firstName}}</span></div>
                            </div>
                            <div class="row no-gutters mb-1">
                                <div class="col-12 col-md-auto mr-2">Last Name:</div>
                                <div class="col-12 col-md-auto"><span class="font-weight-bold">{{a.lastName}}</span></div>
                            </div>
                            <div class="row no-gutters mb-1">
                                <div class="col-12 col-md-auto mr-2">Job Title:</div>
                                <div class="col-12 col-md-auto"><span class="font-weight-bold">{{a.jobTitle}}</span></div>
                            </div>
                            <div class="row no-gutters mb-1">
                                <div class="col-12 col-md-auto mr-2">Company:</div>
                                <div class="col-12 col-md-auto"><span class="font-weight-bold">{{a.company}}</span></div>
                            </div>
                            <div class="row no-gutters mb-1">
                                <div class="col-12 col-md-auto mr-2">Date:</div>
                                <div class="col-12 col-md-auto"><span class="font-weight-bold">{{a.date}}</span></div>
                            </div>
                        </div>
                        <div class="row mt-3 d-print-none">
                            <div class="col">
                                <button type="button" class="btn btn-outline-secondary" @click="editHydro">Edit</button>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-5 d-print-none">
                        <div class="col-12">
                            <button type="button" class="btn btn-secondary" v-on:click="printPage">Print</button>
                            <button type="button" class="btn btn-primary float-right" v-on:click.once="submit">Submit data</button>
                        </div>
                    </div>
                </div>
			</main>
		</div>

    <!-- add before this -->
    </div>
</template>
<script>
    import $ from 'jquery';
    //import axios from 'axios';
    //import DataAccess from '@/libraries/DataAccess';
    import ParticipationAgreementWord from '@/components/Wording/ParticipationAgreement';
    import HydroAgreementWord from '@/components/Wording/HydroAgreement';

    export default {
        name: 'summary-page',
        components: {
            ParticipationAgreementWord,
            HydroAgreementWord
        },
        data: function () {
            return {
                account: [],
                hasAccount: false,
                accountType: "",
                participationFullname: "",
                participationJobtitle: "",
                participationSignDate: "",
            }
        },
        mounted() {
            this.$store.dispatch("GET_CONTACT");

            let hasAccount = (this.$store.getters.HASACCOUNT === 'true' || this.$store.getters.HASACCOUNT);
            if (hasAccount === "false" || hasAccount === false)
                hasAccount = false;
            this.hasAccount = hasAccount;

            this.accountType = this.$store.getters.ACCOUNTTYPE;
        },
        computed: {
            contactList() {
                let data = this.$store.getters.CONTACT_LIST;
                if (data.length === 0) {
                    data = this.$store.getters.CONTACT;
                }
                else {
                    data = data[0];
                }

                return data;
            },
            propertyList() {
                let data = this.$store.getters.PROPERTYLIST;

                return data;
            },
            hydroList() {
                let data = this.$store.getters.HYDRO;

                return data;
            },
            participationList() {
                let data = this.$store.getters.PARTICIPATIONAGREEMENT;
                return data;
            },
            hydroLink() {
                let hydroPath = {
                    name: 'HydroAgreement',
                    params: { 
                        data: this.$store.getters.HYDRO_B64_DATA
                    }
                }
                const routeUrl = this.$router.resolve(hydroPath);
                
                return window.location.origin + window.location.pathname + routeUrl.href;
            },
            
            participantList() {
                let data = this.$store.getters.PARTICIPANT;

                return data;
            },
            participantLink() {
                let participant = this.participantList;
                let participationAgreement = this.participationList;
                let data = {};
                data.participantName = participant[0].participantName;
                data.fullName = participant[0].fullName;
                data.jobTitle = participant[0].jobTitle;
                data.address = participant[0].address;
                data.phone = participant[0].phone;
                data.email = participant[0].email;
                data.signAgreement = participationAgreement[0].signAgreement;
                data.signDate = participationAgreement[0].signDate;
                let link = btoa(JSON.stringify([data]));

                let participantPath = {
                    name: 'ParticipationAgreement',
                    params: {
                        data: link
                    }
                }

                const routeUrl = this.$router.resolve(participantPath);
                
                return window.location.origin + window.location.pathname + routeUrl.href;
            }
        },
        methods: {
            getAccountInfo(index) {
                let data = this.$store.getters.PROPERTYLIST;
                let detail = data[index];
                let l = detail.length;
                let account = detail[l - 1].account;
                
                return account;
            },
            prevpage() {
                this.$router.push({ name: 'Detail', params: { parameters: this.contact } });
            },
            submit() {
                let url = process.env.VUE_APP_BEDP_API + "/api/email";
    
                let data = {
                    contact: this.contactList, property: this.propertyList,
                    hydro: this.hydroList, participation: this.participationList,
                    hydroLink: this.hydroLink, participant: this.participantList,
                    participantLink: this.participantLink
                };
                
                $.ajax({
                    type: "POST",
                    url: url,
                    data: data,
                    dataType: "json",
                    cache: false,
                    crossDomain: true
                });
                //let qs = require("qs");
                
                //axios.post( url, qs.stringify(data));

                // clear data
                this.$store.replaceState({});
                // go to thank you page
                this.$router.push({ name: "Thankyou" });
            },
            infoclicked: function (question) {
                window.open('https://portfoliomanager.energystar.gov/pm/glossary#' + question.trim().charAt(0));
            },
            expandAll() {
                // Disable the expand all link

                var id = $("#expandAll").attr('data-target');

                $("#expandAll").addClass('disabled');

                // Enable the collapse all link
                $('.collapseAll[data-target="' + id + '"]').removeClass('disabled');

                for (let i = 0; i < this.propertyList.length; i++) {
                    id = "#collapse" + i;
                    // Show all items
                    $(id).addClass("show");
                    //$(id + ' .collapse').collapse('show');

                    // Toggle the icons
                    $("#headingtarget" + i).find('i.fa-chevron-down').toggleClass('fa-chevron-down fa-chevron-up');
                }
            },
            collapseAll() {
            //    alert("collapse all");
                // Disable the collapse all link

                var id = $("#collapseAll").attr('data-target');
                $("#collapseAll").addClass('disabled');

                // Enable the expand all link
                $('.expandAll[data-target="' + id + '"]').removeClass('disabled');

                for (let i = 0; i < this.propertyList.length; i++) {
                    id = "#collapse" + i;
                    // Show all items
                    $(id).removeClass("show");
                    //$(id + ' .collapse').collapse('show');

                    // Toggle the icons
                    $("#headingtarget" + i).find('i.fa-chevron-up').toggleClass('fa-chevron-down fa-chevron-up');
                }

                // Hide all items
                //$(id + ' .collapse').collapse('hide');

                // Toggle the icons
                //$(id).find('i.fa-chevron-up').toggleClass('fa-chevron-down fa-chevron-up');
            },
            expandCollapse(p) {
                //var result = $("#headingtarget" + p).find('i.fa-chevron-up').length;
                var show = $("#collapse" + p).attr("class").indexOf("show");

                if (show > -1 )
                    $("#headingtarget" + p).find('i.fa-chevron-up').toggleClass('fa-chevron-down fa-chevron-up');
                else
                    $("#headingtarget" + p).find('i.fa-chevron-down').toggleClass('fa-chevron-down fa-chevron-up');

            },
            editContact() {
                this.$store.dispatch("SAVE_SUMMARYPAGE", true);
                this.$router.push({ name: "Contact" });
            },
            editBuilding() {
                this.$store.dispatch("SAVE_SUMMARYPAGE", true);
                this.$router.push({ name: "Detail" });
            },
            editParticipant() {
                this.$store.dispatch("SAVE_SUMMARYPAGE", true);
                this.$router.push({ name: "Home" });
            },
            editParticipation() {
                this.$store.dispatch("SAVE_SUMMARYPAGE", true);
                this.$router.push({ name: "Home" });
            },
            editHydro() {
                this.$store.dispatch("SAVE_SUMMARYPAGE", true);
                this.$router.push({ name: "HydroAgreement" });
            },
            printPage() {
                window.print();
            }
        }
    }
</script>
